var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.2675 15.3367C6.01618 14.3483 7.99132 13.8303 10 13.8333C12.0833 13.8333 14.0392 14.3792 15.7325 15.3367M12.5 8.83333C12.5 9.49637 12.2366 10.1323 11.7678 10.6011C11.2989 11.0699 10.663 11.3333 10 11.3333C9.33696 11.3333 8.70107 11.0699 8.23223 10.6011C7.76339 10.1323 7.5 9.49637 7.5 8.83333C7.5 8.17029 7.76339 7.53441 8.23223 7.06557C8.70107 6.59672 9.33696 6.33333 10 6.33333C10.663 6.33333 11.2989 6.59672 11.7678 7.06557C12.2366 7.53441 12.5 8.17029 12.5 8.83333ZM17.5 10.5C17.5 11.4849 17.306 12.4602 16.9291 13.3701C16.5522 14.2801 15.9997 15.1069 15.3033 15.8033C14.6069 16.4997 13.7801 17.0522 12.8701 17.4291C11.9602 17.806 10.9849 18 10 18C9.01509 18 8.03982 17.806 7.12987 17.4291C6.21993 17.0522 5.39314 16.4997 4.6967 15.8033C4.00026 15.1069 3.44781 14.2801 3.0709 13.3701C2.69399 12.4602 2.5 11.4849 2.5 10.5C2.5 8.51088 3.29018 6.60322 4.6967 5.1967C6.10322 3.79018 8.01088 3 10 3C11.9891 3 13.8968 3.79018 15.3033 5.1967C16.7098 6.60322 17.5 8.51088 17.5 10.5Z",
    stroke: "#4254EA",
    strokeWidth: 1.70139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.695385fa2e38b46c68e6cd46940c4f46.svg";
export { ForwardRef as ReactComponent };